import { render, staticRenderFns } from "./CreateAccountPropBtn.vue?vue&type=template&id=5a32a8e5&"
import script from "./CreateAccountPropBtn.vue?vue&type=script&lang=js&"
export * from "./CreateAccountPropBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports